import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Checkbox, Grid, Select} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import CommercialTable from '../../../../common/components/commercialTable/commercialTable';
import {DefaultColumnFilter} from '../../../../manageOrders/components/internalCommons/TableFilters';
import WtsCourseStatusModal from './courseStatusModal';
import WtsCourseStatusTechDetailsModal from './courseStatusTechDetailsModal';

const {
  getWtsCoursesStatus,
  updateWtsCoursesStatus,
} = Actions;

function WtsCoursesStatus({activeTab}) {
  const wtsCoursesStatus = useSelector((state) => state.wtsCoursesStatus.list);
  const areaSelected = useSelector((state) => state.wtsAreas.areaSelected);
  const dispatch = useDispatch();

  useEffect(() => {
    if (areaSelected && activeTab === 6) {
      dispatch(getWtsCoursesStatus());
    }
  }, [areaSelected, activeTab]);

  const updateStatus = (e, checkedValue, item) => {
    e.preventDefault();
    dispatch(updateWtsCoursesStatus({'data': {...item, 'status': checkedValue ? 'A' : 'I'}}));
  };

  const SelectColumnFilter = ({
    'column': {filterValue, setFilter},
  }) => {
    const options = [
      {'key': 'all', 'value': '', 'text': 'TODOS'},
      {'key': 'active', 'value': 'A', 'text': 'ACTIVO'},
      {'key': 'inactive', 'value': 'I', 'text': 'INACTIVO'},
    ];

    return (
      <Select
        compact
        placeholder="TODOS"
        value={filterValue || ''}
        options={options}
        style={{'minWidth': '120px', 'width': '100%'}}
        onChange={(e, {value}) => {
          setFilter(value || '');
          if (!value) {
            dispatch(getWtsCoursesStatus());
          }
        }}
      />
    );
  };

  const columns = [
    {
      'Header': () => <span className="header-title">CÓDIGO</span>,
      'accessor': 'code',
    },
    {
      'Header': () => <span className="header-title">SECUENCIA</span>,
      'accessor': 'secuencia',
      'Cell': (item) => (
        <div>
          <div>{item.value || 'Sin asignar'}</div>
          <small style={{'color': 'gray'}}> {item.row.original.gestor_email} </small>
        </div>
      ),
    },
    {
      'Header': () => <span className="header-title">DESCRIPCIÓN</span>,
      'accessor': 'course_status',
    },
    {
      'Header': () => <span className="header-title">ESTADO</span>,
      'accessor': 'status',
      'Filter': SelectColumnFilter,
      'filter': (rows, id, filterValue) => {
        if (filterValue === '' || !filterValue) {
          return rows;
        }
        return rows.filter((row) => row.values[id] === filterValue);
      },
      'Cell': (item) => {
        return (
          <Checkbox
            toggle
            checked={item.value === 'A'}
            className='green'
            onChange={(e, input) => updateStatus(e, input.checked, item.row.original)}
          />
        );
      },
    },
    {
      'Header': () => <span className="header-title">ACCIONES</span>,
      'id': 'status_actions',
      'width': 1,
      'Cell': (item) => {
        return (
          <div className='flex center end'>
            <WtsCourseStatusModal mode='edit' courseStatusToEdit={item.row.original} />
          </div>
        );
      },
    },
  ];

  return (
    <Grid padded>
      <Grid.Row style={{'padding': 0}}>
        <Grid.Column textAlign='left' width={14}>
          <WtsCourseStatusModal mode='new' />
        </Grid.Column>
        <Grid.Column width={2} textAlign='right'>
          <WtsCourseStatusTechDetailsModal />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={8}>
          <CommercialTable
            columns={columns}
            data={wtsCoursesStatus}
            defaultColumnFilter={DefaultColumnFilter}
            defaultPagination={10}
            initialState={{
              'filters': [
                {
                  'id': 'status',
                  'value': '',
                },
              ],
            }}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}

export default WtsCoursesStatus;
